import { render, staticRenderFns } from "./vsChips.vue?vue&type=template&id=08c01eb6&lang=html&"
import script from "./vsChips.vue?vue&type=script&lang=js&"
export * from "./vsChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsChips.vue"
export default component.exports